import React, { useState, useEffect } from "react";
import { useNavigate, Link } from "react-router-dom";
import toast from "react-hot-toast";

function Login() {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

  useEffect(() => {
    if (sessionStorage.getItem("isLoggedIn") === "true") {
      navigate("/");
    }
  }, [navigate]);

  const handleLogin = (e) => {
    e.preventDefault();

    if (!email || !password) {
      toast.error("Please enter both fields!");
      return;
    }

    sessionStorage.setItem("isLoggedIn", "true");
    sessionStorage.setItem("userEmail", email);

    toast.success("Login Successful!");
    navigate("/");
  };

  return (
    <div className="login-section">
      <div className="login-card-wrapper">
        {/* LEFT PANEL */}
        <div className="login-info">
          <h2 style={{ color: "white" }}>Your Printing Hub</h2>
          <p style={{ color: "white" }}>
            Log in to access your saved carts, track orders, and enjoy a
            seamless shopping experience.
          </p>
          <img src="/assets/img/normal/login-illustration.svg" alt="login" />
        </div>

        {/* RIGHT PANEL */}
        <div className="login-form-card">
          <h3>Sign In</h3>
          <p className="form-sub">Welcome back! Please login to continue.</p>

          <form onSubmit={handleLogin}>
            <div className="form-group">
              <label>Email Address</label>
              <input
                type="email"
                className="input"
                placeholder="your@example.com"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />
            </div>

            <div className="form-group">
              <label>Password</label>
              <input
                type="password"
                className="input"
                placeholder="Enter password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
              />
            </div>

            <button type="submit" className="btn-login">
              Login
            </button>
          </form>

          <p className="register-text">
            New here? <Link to="/register-now">Create an account</Link>
          </p>
        </div>
      </div>

      {/* STYLES */}
      <style>{`
        .login-section {
          min-height: 100vh;
          background: linear-gradient(135deg, #eef3ff, #dce9ff);
          display:flex;
          justify-content:center;
          align-items:center;
          padding: 20px;
        }

        .login-card-wrapper {
          display: flex;
          background: white;
          width: 900px;
          border-radius: 18px;
          box-shadow: 0px 15px 40px rgba(0,0,0,0.07);
          overflow: hidden;
        }

        /* LEFT SECTION */
        .login-info {
          flex: 1;
          background: #0b61d6;
          color: white;
          padding: 45px 35px;
          display: flex;
          flex-direction: column;
          justify-content: center;
        }

        .login-info h2 {
          font-size: 34px;
          font-weight: 800;
          margin-bottom: 10px;
        }

        .login-info p {
          font-size: 15px;
          opacity: 0.9;
          line-height: 1.6;
          margin-bottom: 25px;
        }

        .login-info img {
          width: 80%;
          max-width: 320px;
          margin-top: auto;
        }

        /* RIGHT SECTION */
        .login-form-card {
          flex: 1;
          padding: 40px 35px;
        }

        .login-form-card h3 {
          font-size: 28px;
          font-weight: 700;
          color: #222;
        }

        .form-sub {
          color: #666;
          margin-bottom: 28px;
        }

        .form-group {
          margin-bottom: 20px;
        }

        .form-group label {
          font-size: 14px;
          font-weight: 600;
          display: block;
          margin-bottom: 6px;
        }

        .input {
          width: 100%;
          padding: 13px 14px;
          font-size: 15px;
          border-radius: 10px;
          border: 1px solid #ccc;
          outline: none;
          transition: 0.25s;
        }

        .input:focus {
          border-color: #0b61d6;
          box-shadow: 0 0 0 3px rgba(11, 97, 214, 0.17);
        }

        .btn-login {
          width: 100%;
          background: #0b61d6;
          padding: 14px;
          border-radius: 10px;
          color: white;
          border: none;
          font-size: 16px;
          font-weight: 700;
          cursor: pointer;
          transition: 0.3s;
          margin-top: 10px;
        }

        .btn-login:hover {
          background: #084eb7;
        }

        .register-text {
          margin-top: 18px;
          color: #555;
        }

        .register-text a {
          color: #0b61d6;
          font-weight: 700;
          text-decoration: none;
        }

        .register-text a:hover {
          text-decoration: underline;
        }

        /* RESPONSIVE */
        @media (max-width: 900px) {
          .login-card-wrapper {
            flex-direction: column;
            width: 100%;
          }

          .login-info img {
            display: none;
          }
        }

      `}</style>
    </div>
  );
}

export default Login;
